<template>
  <div id="userAdminList">
    <el-breadcrumb separator="/">
      <el-breadcrumb-item :to="{ path: `/${currentClientId}/user-admin` }">User Admin</el-breadcrumb-item>
    </el-breadcrumb>
    <hia-loading v-if="loading"></hia-loading>
    <div v-if="!loading" class="top-margin">
      <el-row :gutter="24">
        <el-col :span="24">
          <div style="float: left;" v-if="!rebuttalUsersOnly">
            <el-select :default-first-option="true" v-model="grouping" placeholder="Filter by Access" filterable clearable>
              <el-option v-for="item in dropdown" :key="item.key" :label="item.value" :value="item.key"> </el-option>
            </el-select>
          </div>
          <el-button v-if="(userAdmin() || documentManagerAdmin()) && !rebuttalUsersOnly" @click="createNewUser" type="primary" class="pull-right"><i
              class="mdi mdi-account-multiple-plus coderIcon"></i>New User </el-button>
          <div style="float: right; margin: 0px 20px 0px 0px;">
            <el-input prefix-icon="el-icon-search" size="mini" placeholder="Search Query..." type="text" class="globalSearch" v-model="filterCriteria"> </el-input>
          </div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <el-table id="userList" v-loading="tableLoading" element-loading-spinner="nucleus-loader" :data="contactsPagination" style="width: 100%; margin-top: 20px;">
            <el-table-column prop="name" label="Name" sortable>
              <template slot-scope="scope">
                <router-link v-if="!rebuttalUsersOnly" :to="`user-admin/${scope.row.id}`">{{ scope.row.name }}</router-link>
                <span v-if="rebuttalUsersOnly">{{ scope.row.name }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="emailAddress" label="Email Address" sortable></el-table-column>
            <el-table-column prop="title" label="Title" sortable></el-table-column>
            <el-table-column prop="notes" label="Notes" sortable v-if="!rebuttalUsersOnly"></el-table-column>
            <el-table-column prop="inactive" label="Active" width="100px" sortable>
              <template slot-scope="scope">
                <div>
                  <el-switch v-model="scope.row.inactive" inactive-color="#13ce66" active-color="#ff4949" @change="putContact(scope.row)">
                  </el-switch>
                </div>
              </template>
            </el-table-column>
          </el-table>
        </el-col>
      </el-row>
      <el-pagination class=" pager" background :pager-count="15" layout="prev, pager, next, slot" :page-size="itemsPerPage" :total="filteredContacts.length"
        @current-change="handleCurrentChange" :hide-on-single-page="true" small> </el-pagination>
    </div>
  </div>
</template>

<script>
  import { mapState, mapActions } from 'vuex'
  import HiaAuthorization from '@/mixins/hiaAuthorization'
  import hiaFilters from '@/mixins/hiaFilters'

  export default {
    props: ['rebuttalUsersOnly'],
    data: function () {
      return {
        loading: false,
        tableLoading: false,
        filterCriteria: '',
        currentPage: 1,
        itemsPerPage: 10,
        isIE11: !!navigator.userAgent.match(/Trident\/7\./),
        grouping: '',
        dropdown: [
          { key: '8', value: 'Nucleus User' },
          { key: '11', value: 'Coding Dashboard' },
          { key: '12', value: 'Review Dashboard' },
          { key: '13', value: 'Nucleus User Admin' },
          { key: '3', value: 'Coding Logs' },
          { key: '4', value: 'Coding Schedule' },
          { key: '5', value: 'Review Schedule' },
          { key: '21', value: 'Rebuttal User' },
          { key: '22', value: 'Rebuttal Manager' }
        ]
      }
    },
    name: 'UserAdminList',
    mixins: [HiaAuthorization, hiaFilters],
    components: {},
    methods: {
      ...mapActions('userAdmin/', ['GET_CONTACTS', 'GET_REBUTTAL_USERS', 'PUT_CONTACT']),
      initialize() {
        // user admin check
        if (!this.userAdmin() && !this.rebuttalManager()) {
          this.$router.push('/')
          return
        }
        this.loading = true
        let userClients = []
        this.clients.forEach((v, i) => {
          if (this.isUserAdminClient(v.clientNumber)) {
            userClients.push(v)
          }
        })
        if (this.user.email.includes('@hiacode.com')) {
          userClients = this.clients.find(x => x.clientNumber === 'zpawl') ? [this.clients.find(x => x.clientNumber === 'zpawl')] : userClients
        }

        if (this.rebuttalUsersOnly) {
          this.GET_REBUTTAL_USERS(userClients).then(() => {
            this.loading = false
          })
        } else {
          this.GET_CONTACTS(userClients).then(() => {
            this.loading = false
          })
        }
      },
      createNewUser() {
        this.$router.push('user-admin/new')
      },
      handleCurrentChange(val) {
        this.currentPage = val
      },
      async putContact(row) {
        let message = ''
        if (row.inactive) {
          message = `Are you sure you want to deactivate ${row.name}?`
        } else {
          message = `Are you sure you want to activate ${row.name}?`
        }

        try {
          await this.$confirm(message, 'Update User', {
            confirmButtonText: 'Continue',
            cancelButtonText: 'Cancel',
            type: 'warning'
          })
        } catch (e) {
          row.inactive = !row.inactive
          const index = this.contacts.findIndex(x => x.id === row.id)
          this.$set(this.contacts, index, row)
          return
        }

        try {
          this.tableLoading = true
          await this.PUT_CONTACT(row)
          this.tableLoading = false
          this.$message({
            message: 'Nucleus User Updated',
            type: 'success'
          })
        } catch (e) {
          this.$message({
            message: 'Error Updating Nucleus User',
            type: 'error'
          })
          this.tableLoading = false
        }
      }
    },
    created: function () {
      this.initialize()
    },
    computed: {
      ...mapState('user/', ['currentClient', 'currentClientId', 'user', 'clients']),
      ...mapState('userAdmin/', ['contacts', 'distinctDomains', 'contactRoles', 'distinctDomains']),
      filteredContacts() {
        if (this.contacts.length) {
          let data = this.contacts
          // filter by grouping
          if (this.grouping) {
            data = data.filter(x => x.roles.split(',').some(s => s === this.grouping))
          }

          return this.filterList(data, this.filterCriteria, ['name', 'emailAddress', 'title', 'notes'])
        }
        return []
      },
      contactsPagination() {
        let length = this.filteredContacts.length
        let from = length <= this.itemsPerPage ? 0 : (this.currentPage - 1) * this.itemsPerPage + 1
        let to = this.currentPage * this.itemsPerPage
        return this.filteredContacts.slice(from, to)
      }
    },
    watch: {
      $route() {
        this.initialize()
      }
    }
  }
</script>

<style scoped>
  #userList>>>.caret-wrapper {
    display: none;
  }

  .coderIcon {
    font-size: 20px;
    float: left;
    height: 12px;
    margin: -3px 5px 0px 0px;
  }
</style>
